import { Component } from "react";

// Wraps the drawing studio so a render-time error degrades to a recoverable
// message instead of blanking the whole app (previously any throw unmounted
// the entire SPA to a black page). Resetting remounts the children fresh.
export class StudioErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, tries: 0 };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Studio crash:", error, info?.componentStack);
  }

  reset = () => this.setState((s) => ({ error: null, tries: s.tries + 1 }));

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="studio-error-boundary"
          className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-4 bg-zinc-950 p-8 text-center"
        >
          <div className="max-w-md space-y-2">
            <h2 className="text-lg font-bold text-zinc-100">
              Something went wrong in the drawing
            </h2>
            <p className="text-sm text-zinc-400">
              The studio hit an unexpected error and paused to keep your work
              safe. Your saved data is untouched — reset the view to continue.
            </p>
            <p className="font-mono-data break-words text-[11px] text-zinc-600">
              {String(this.state.error?.message || this.state.error)}
            </p>
          </div>
          <button
            type="button"
            data-testid="studio-error-reset"
            onClick={this.reset}
            className="rounded-full bg-amber-500 px-5 py-2 text-sm font-bold text-zinc-950 transition-colors duration-150 hover:bg-amber-400"
          >
            Reset the view
          </button>
        </div>
      );
    }
    return (
      <div key={this.state.tries} className="contents">
        {this.props.children}
      </div>
    );
  }
}
